import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "getting-started"
    }}>{`Getting started`}</h1>
    <h2 {...{
      "id": "install"
    }}>{`install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install react-elastic-carousel
`}</code></pre>
    <h2 {...{
      "id": "import"
    }}>{`Import`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import Carousel from 'react-elastic-carousel'
`}</code></pre>
    <h2 {...{
      "id": "play"
    }}>{`play`}</h2>
    <Playground __position={0} __code={'<Carousel itemsToShow={1}>\n  <Item>1</Item>\n  <Item>2</Item>\n  <Item>3</Item>\n  <Item>4</Item>\n  <Item>5</Item>\n  <Item>6</Item>\n</Carousel>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Carousel itemsToShow={1} mdxType="Carousel">
    <Item mdxType="Item">1</Item>
    <Item mdxType="Item">2</Item>
    <Item mdxType="Item">3</Item>
    <Item mdxType="Item">4</Item>
    <Item mdxType="Item">5</Item>
    <Item mdxType="Item">6</Item>
  </Carousel>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Carousel} mdxType="Props" />
    <h2 {...{
      "id": "styling"
    }}>{`Styling`}</h2>
    <p>{`Almost every element in `}<inlineCode parentName="p">{`react-elastic-carousel`}</inlineCode>{` has a css class with the `}<inlineCode parentName="p">{`rec-`}</inlineCode>{` prefix (rec is short React Elastic Carousel).`}<br parentName="p"></br>{`
`}{`For example: `}<inlineCode parentName="p">{`rec-arrow`}</inlineCode>{` for both arrow buttons or `}<inlineCode parentName="p">{`rec-arrow-left`}</inlineCode>{` just for the left one. `}</p>
    <p>{`You can see a code example `}<a parentName="p" {...{
        "href": "/react-elastic-carousel/styling"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      